import { render, staticRenderFns } from "./returnproductcustom.vue?vue&type=template&id=66b21ed6&scoped=true&"
import script from "./returnproductcustom.vue?vue&type=script&lang=js&"
export * from "./returnproductcustom.vue?vue&type=script&lang=js&"
import style0 from "./returnproductcustom.vue?vue&type=style&index=0&id=66b21ed6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b21ed6",
  null
  
)

export default component.exports